import { StoredView } from "@/graphql/generated/graphql";
import { groupBy } from "@/lib/groupBy";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { QueryClient } from "@tanstack/react-query";

/**
 * Populates the React Query cache with stored views for the workspace.
 * This uses React Query cache management for view data.
 *
 * @param queryClient The React Query client instance
 * @param workspaceId The workspace ID
 * @param storedViewList The list of stored views
 */
export function onGetStoredViewListForWorkspace({
  queryClient,
  workspaceId,
  storedViewList,
}: {
  queryClient: QueryClient;
  workspaceId: string;
  storedViewList: StoredView[];
}) {
  const groupedStoredViews = groupBy(storedViewList, (storedView) => storedView.key);

  for (const [key, storedViewList] of groupedStoredViews.entries()) {
    if (!storedViewList) {
      continue;
    }

    // Set the data in React Query cache
    queryClient.setQueryData(queryKeys.storedViews.list(key, workspaceId), storedViewList);
  }
}
